import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api/trpc';

// Label options for the Accounts filter, searched on the server.
export const useCompanyLabels = (input: {
  search: string;
  organizationIds?: string[];
}) =>
  trpc.companies.labels.useQuery(
    {
      search: input.search || undefined,
      organizationIds: input.organizationIds,
    },
    { placeholderData: keepPreviousData, staleTime: 60_000 }
  );
